export const languageTranslations = {
  Abchasisch: ['Abchasisch', 'Abkhaz'],
  Afar: ['Afar', 'Afar'],
  Afrikaans: ['Afrikaans', 'Afrikaans'],
  Akan: ['Akan', 'Akan'],
  Albanisch: ['Albanisch', 'Albanian'],
  Amharisch: ['Amharisch', 'Amharic'],
  Arabisch: ['Arabisch', 'Arabic'],
  Aragonesisch: ['Aragonesisch', 'Aragonese'],
  Armenisch: ['Armenisch', 'Armenian'],
  Assamesisch: ['Assamesisch', 'Assamese'],
  Avarisch: ['Avarisch', 'Avaric'],
  Avestan: ['Avestan', 'Avestan'],
  Aymara: ['Aymara', 'Aymara'],
  Aserbaidschanisch: ['Aserbaidschanisch', 'Azerbaijani'],
  Bambara: ['Bambara', 'Bambara'],
  Baschkirisch: ['Baschkirisch', 'Bashkir'],
  Baskisch: ['Baskisch', 'Basque'],
  Belarussisch: ['Belarussisch', 'Belarusian'],
  Bengali: ['Bengali', 'Bengali'],
  Bhojpuri: ['Bhojpuri', 'Bhojpuri'],
  Bislama: ['Bislama', 'Bislama'],
  Bosnisch: ['Bosnisch', 'Bosnian'],
  Bretonisch: ['Bretonisch', 'Breton'],
  Bulgarisch: ['Bulgarisch', 'Bulgarian'],
  Birmanisch: ['Birmanisch', 'Burmese'],
  Katalanisch: ['Katalanisch', 'Catalan'],
  Chamorro: ['Chamorro', 'Chamorro'],
  Tschetschenisch: ['Tschetschenisch', 'Chechen'],
  Chichewa: ['Chichewa', 'Chichewa'],
  Chinesisch: ['Chinesisch', 'Chinese'],
  Tschuwaschisch: ['Tschuwaschisch', 'Chuvash'],
  Kornisch: ['Kornisch', 'Cornish'],
  Korsisch: ['Korsisch', 'Corsican'],
  Cree: ['Cree', 'Cree'],
  Kroatisch: ['Kroatisch', 'Croatian'],
  Tschechisch: ['Tschechisch', 'Czech'],
  Daenisch: ['Dänisch', 'Danish'],
  Divehi: ['Divehi', 'Divehi'],
  Niederlaendisch: ['Niederländisch', 'Dutch'],
  Dzongkha: ['Dzongkha', 'Dzongkha'],
  Englisch: ['Englisch', 'English'],
  Estnisch: ['Estnisch', 'Estonian'],
  Ewe: ['Ewe', 'Ewe'],
  Faeroeisch: ['Färöisch', 'Faroese'],
  Fidschi: ['Fidschi', 'Fijian'],
  Finnisch: ['Finnisch', 'Finnish'],
  Franzoesisch: ['Französisch', 'French'],
  Fula: ['Fula', 'Fula'],
  Schottisch_Gaelisch: ['Schottisch Gälisch', 'Scottish Gaelic'],
  Galizisch: ['Galizisch', 'Galician'],
  Georgisch: ['Georgisch', 'Georgian'],
  Deutsch: ['Deutsch', 'German'],
  Griechisch: ['Griechisch', 'Greek'],
  Guarani: ['Guarani', 'Guaraní'],
  Gujarati: ['Gujarati', 'Gujarati'],
  Haitianisch: ['Haitianisch', 'Haitian'],
  Hausa: ['Hausa', 'Hausa'],
  Hebraeisch: ['Hebräisch', 'Hebrew'],
  Herero: ['Herero', 'Herero'],
  Hiri_Motu: ['Hiri Motu', 'Hiri Motu'],
  Hindi: ['Hindi', 'Hindi'],
  Ungarisch: ['Ungarisch', 'Hungarian'],
  Indonesisch: ['Indonesisch', 'Indonesian'],
  Zwischensprache: ['Zwischensprache', 'Interlingue'],
  Irisch: ['Irisch', 'Irish'],
  Igbo: ['Igbo', 'Igbo'],
  Inupiaq: ['Inupiaq', 'Inupiaq'],
  Islaendisch: ['Isländisch', 'Icelandic'],
  Italienisch: ['Italienisch', 'Italian'],
  Japanisch: ['Japanisch', 'Japanese'],
  Javanisch: ['Javanisch', 'Javanese'],
  Kalaallisut: ['Kalaallisut', 'Kalaallisut'],
  Kannada: ['Kannada', 'Kannada'],
  Kanuri: ['Kanuri', 'Kanuri'],
  Kaschmir: ['Kaschmir', 'Kashmiri'],
  Kasachisch: ['Kasachisch', 'Kazakh'],
  Khmer: ['Khmer', 'Khmer'],
  Kikuyu: ['Kikuyu', 'Kikuyu'],
  Kirgisisch: ['Kirgisisch', 'Kyrgyz'],
  Komi: ['Komi', 'Komi'],
  Kongo: ['Kongo', 'Kongo'],
  Koreanisch: ['Koreanisch', 'Korean'],
  Kurdisch: ['Kurdisch', 'Kurdish'],
  Luxemburgisch: ['Luxemburgisch', 'Luxembourgish'],
  Limburgisch: ['Limburgisch', 'Limburgish'],
  Lingala: ['Lingala', 'Lingala'],
  Lao: ['Lao', 'Lao'],
  Litauisch: ['Litauisch', 'Lithuanian'],
  Luba_Katanga: ['Luba-Katanga', 'Luba-Katanga'],
  Lettisch: ['Lettisch', 'Latvian'],
  Manx: ['Manx', 'Manx'],
  Mazedonisch: ['Mazedonisch', 'Macedonian'],
  Madagassisch: ['Madagassisch', 'Malagasy'],
  Malaiisch: ['Malaiisch', 'Malay'],
  Malayalam: ['Malayalam', 'Malayalam'],
  Maltesisch: ['Maltesisch', 'Maltese'],
  Moori: ['Mōori', 'Moori'],
  Marshallisch: ['Marshallisch', 'Marshallese'],
  Mongolisch: ['Mongolisch', 'Mongolian'],
  Nauruisch: ['Nauruisch', 'Nauruan'],
  Navajo: ['Navajo', 'Navajo'],
  Noerdliches_Ndebele: ['Nördliches Ndebele', 'Northern Ndebele'],
  Nepali: ['Nepali', 'Nepali'],
  Norwegisch: ['Norwegisch', 'Norwegian'],
  Nuosu: ['Nuosu', 'Nuosu'],
  Suedliches_Ndebele: ['Südliches Ndebele', 'Southern Ndebele'],
  Okzitanisch: ['Okzitanisch', 'Occitan'],
  Ojibwe: ['Ojibwe', 'Ojibwe'],
  Oromo: ['Oromo', 'Oromo'],
  Orija: ['Orija', 'Oriya'],
  Ossetisch: ['Ossetisch', 'Ossetian'],
  Panjabi: ['Panjabi', 'Panjabi'],
  Persisch: ['Persisch', 'Persian'],
  Polnisch: ['Polnisch', 'Polish'],
  Paschtu: ['Paschtu', 'Pashto'],
  Portugiesisch: ['Portugiesisch', 'Portuguese'],
  Quechua: ['Quechua', 'Quechua'],
  Raetoromanisch: ['Rätoromanisch', 'Romansh'],
  Rumaenisch: ['Rumänisch', 'Romanian'],
  Russisch: ['Russisch', 'Russian'],
  Sardisch: ['Sardisch', 'Sardinian'],
  Sindhi: ['Sindhi', 'Sindhi'],
  Samoanisch: ['Samoanisch', 'Samoan'],
  Sango: ['Sango', 'Sango'],
  Serbisch: ['Serbisch', 'Serbian'],
  Shona: ['Shona', 'Shona'],
  Singhalesisch: ['Singhalesisch', 'Sinhalese'],
  Slowakisch: ['Slowakisch', 'Slovak'],
  Slowenisch: ['Slowenisch', 'Slovene'],
  Somali: ['Somali', 'Somali'],
  Suedliches_Sotho: ['Südliches Sotho', 'Southern Sotho'],
  Spanisch: ['Spanisch', 'Spanish'],
  Sundanesisch: ['Sundanesisch', 'Sundanese'],
  Suaheli: ['Suaheli', 'Swahili'],
  Schwati: ['Schwati', 'Swati'],
  Schwedisch: ['Schwedisch', 'Swedish'],
  Tamil: ['Tamil', 'Tamil'],
  Telugu: ['Telugu', 'Telugu'],
  Tadschikisch: ['Tadschikisch', 'Tajik'],
  Thailaendisch: ['Thailändisch', 'Thai'],
  Tigrinja: ['Tigrinja', 'Tigrinya'],
  Turkmenisch: ['Turkmenisch', 'Turkmen'],
  Tagalog: ['Tagalog', 'Tagalog'],
  Tswana: ['Tswana', 'Tswana'],
  Tonga: ['Tonga', 'Tonga'],
  Tuerkisch: ['Türkisch', 'Turkish'],
  Tsonga: ['Tsonga', 'Tsonga'],
  Tatarisch: ['Tatarisch', 'Tatar'],
  Tahitianisch: ['Tahitianisch', 'Tahitian'],
  Uiguren: ['Uiguren', 'Uyghur'],
  Urdu: ['Urdu', 'Urdu'],
  Ukrainisch: ['Ukrainisch', 'Ukrainian'],
  Usbekisch: ['Usbekisch', 'Uzbek'],
  Venda: ['Venda', 'Venda'],
  Vietnamesisch: ['Vietnamesisch', 'Vietnamese'],
  Wallonisch: ['Wallonisch', 'Walloon'],
  Walisisch: ['Walisisch', 'Welsh'],
  Wolof: ['Wolof', 'Wolof'],
  Westfriesisch: ['Westfriesisch', 'Western Frisian'],
  Xhosa: ['Xhosa', 'Xhosa'],
  Jiddisch: ['Jiddisch', 'Yiddish'],
  Yoruba: ['Yoruba', 'Yoruba'],
  Zulu: ['Zulu', 'Zulu'],
  otherLanguage: ['Sonstige', 'Other'],
};

export enum MatchingLanguage {
  Abchasisch = 'Abchasisch',
  Afar = 'Afar',
  Afrikaans = 'Afrikaans',
  Akan = 'Akan',
  Albanisch = 'Albanisch',
  Amharisch = 'Amharisch',
  Arabisch = 'Arabisch',
  Aragonesisch = 'Aragonesisch',
  Armenisch = 'Armenisch',
  Assamesisch = 'Assamesisch',
  Avarisch = 'Avarisch',
  Avestan = 'Avestan',
  Aymara = 'Aymara',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bambara = 'Bambara',
  Baschkirisch = 'Baschkirisch',
  Baskisch = 'Baskisch',
  Belarussisch = 'Belarussisch',
  Bengali = 'Bengali',
  Bhojpuri = 'Bhojpuri',
  Bislama = 'Bislama',
  Bosnisch = 'Bosnisch',
  Bretonisch = 'Bretonisch',
  Bulgarisch = 'Bulgarisch',
  Birmanisch = 'Birmanisch',
  Katalanisch = 'Katalanisch',
  Chamorro = 'Chamorro',
  Tschetschenisch = 'Tschetschenisch',
  Chichewa = 'Chichewa',
  Chinesisch = 'Chinesisch',
  Tschuwaschisch = 'Tschuwaschisch',
  Kornisch = 'Kornisch',
  Korsisch = 'Korsisch',
  Cree = 'Cree',
  Kroatisch = 'Kroatisch',
  Tschechisch = 'Tschechisch',
  Daenisch = 'Daenisch',
  Divehi = 'Divehi',
  Niederlaendisch = 'Niederlaendisch',
  Dzongkha = 'Dzongkha',
  Englisch = 'Englisch',
  Estnisch = 'Estnisch',
  Ewe = 'Ewe',
  Faeroeisch = 'Faeroeisch',
  Fidschi = 'Fidschi',
  Finnisch = 'Finnisch',
  Franzoesisch = 'Franzoesisch',
  Fula = 'Fula',
  Schottisch_Gaelisch = 'Schottisch_Gaelisch',
  Galizisch = 'Galizisch',
  Georgisch = 'Georgisch',
  Deutsch = 'Deutsch',
  Griechisch = 'Griechisch',
  Guarani = 'Guarani',
  Gujarati = 'Gujarati',
  Haitianisch = 'Haitianisch',
  Hausa = 'Hausa',
  Hebraeisch = 'Hebraeisch',
  Herero = 'Herero',
  Hiri_Motu = 'Hiri_Motu',
  Ungarisch = 'Ungarisch',
  Indonesisch = 'Indonesisch',
  Zwischensprache = 'Zwischensprache',
  Irisch = 'Irisch',
  Igbo = 'Igbo',
  Inupiaq = 'Inupiaq',
  Islaendisch = 'Islaendisch',
  Italienisch = 'Italienisch',
  Japanisch = 'Japanisch',
  Javanisch = 'Javanisch',
  Kalaallisut = 'Kalaallisut',
  Kannada = 'Kannada',
  Kanuri = 'Kanuri',
  Kaschmir = 'Kaschmir',
  Kasachisch = 'Kasachisch',
  Khmer = 'Khmer',
  Kikuyu = 'Kikuyu',
  Kirgisisch = 'Kirgisisch',
  Komi = 'Komi',
  Kongo = 'Kongo',
  Koreanisch = 'Koreanisch',
  Kurdisch = 'Kurdisch',
  Luxemburgisch = 'Luxemburgisch',
  Limburgisch = 'Limburgisch',
  Lingala = 'Lingala',
  Lao = 'Lao',
  Litauisch = 'Litauisch',
  Luba_Katanga = 'Luba_Katanga',
  Lettisch = 'Lettisch',
  Manx = 'Manx',
  Mazedonisch = 'Mazedonisch',
  Madagassisch = 'Madagassisch',
  Malaiisch = 'Malaiisch',
  Malayalam = 'Malayalam',
  Maltesisch = 'Maltesisch',
  Moori = 'Moori',
  Marshallisch = 'Marshallisch',
  Mongolisch = 'Mongolisch',
  Nauruisch = 'Nauruisch',
  Navajo = 'Navajo',
  Noerdliches_Ndebele = 'Noerdliches_Ndebele',
  Nepali = 'Nepali',
  Norwegisch = 'Norwegisch',
  Nuosu = 'Nuosu',
  Suedliches_Ndebele = 'Suedliches_Ndebele',
  Okzitanisch = 'Okzitanisch',
  Ojibwe = 'Ojibwe',
  Oromo = 'Oromo',
  Orija = 'Orija',
  Ossetisch = 'Ossetisch',
  Panjabi = 'Panjabi',
  Persisch = 'Persisch',
  Polnisch = 'Polnisch',
  Paschtu = 'Paschtu',
  Portugiesisch = 'Portugiesisch',
  Quechua = 'Quechua',
  Raetoromanisch = 'Raetoromanisch',
  Rumaenisch = 'Rumaenisch',
  Russisch = 'Russisch',
  Sardisch = 'Sardisch',
  Sindhi = 'Sindhi',
  Samoanisch = 'Samoanisch',
  Sango = 'Sango',
  Serbisch = 'Serbisch',
  Shona = 'Shona',
  Singhalesisch = 'Singhalesisch',
  Slowakisch = 'Slowakisch',
  Slowenisch = 'Slowenisch',
  Somali = 'Somali',
  Suedliches_Sotho = 'Suedliches_Sotho',
  Spanisch = 'Spanisch',
  Sundanesisch = 'Sundanesisch',
  Suaheli = 'Suaheli',
  Schwati = 'Schwati',
  Schwedisch = 'Schwedisch',
  Tamil = 'Tamil',
  Telugu = 'Telugu',
  Tadschikisch = 'Tadschikisch',
  Thailaendisch = 'Thailaendisch',
  Tigrinja = 'Tigrinja',
  Turkmenisch = 'Turkmenisch',
  Tagalog = 'Tagalog',
  Tswana = 'Tswana',
  Tonga = 'Tonga',
  Tuerkisch = 'Tuerkisch',
  Tsonga = 'Tsonga',
  Tatarisch = 'Tatarisch',
  Tahitianisch = 'Tahitianisch',
  Uiguren = 'Uiguren',
  Ukrainisch = 'Ukrainisch',
  Usbekisch = 'Usbekisch',
  Venda = 'Venda',
  Vietnamesisch = 'Vietnamesisch',
  Wallonisch = 'Wallonisch',
  Walisisch = 'Walisisch',
  Wolof = 'Wolof',
  Westfriesisch = 'Westfriesisch',
  Xhosa = 'Xhosa',
  Jiddisch = 'Jiddisch',
  Yoruba = 'Yoruba',
  Zulu = 'Zulu',
  otherLanguage = 'otherLanguage',
}

//   new EnumAttributeDefinition({
//     type: 'enum',
//     key: 'faculty',
//     gqlType: 'enum',
//     translations: [
//       new LanguageTranslationPair({ language: Language.GERMAN, translation: 'Fachbereich Hochschule Fulda' }),
//       new LanguageTranslationPair({ language: Language.ENGLISH, translation: 'Department Hochschule Fulda' }),
//     ],
//     label: 'Fachbereich Hochschule Fulda',
//     options: [
//       ['Angewandte Informatik', 'Applied Computer Science'],
//       ['Elektrotechnik und Informationstechnik', 'Electrical Engineering and Information Technology'],
//       ['Gesundheitswissenschaften', 'Health Sciences'],
//       ['Lebensmitteltechnologie', 'Food Technology'],
//       ['Oecotrophologie', 'Nutritional, Food and Consumer Sciences'],
//       ['Sozial- und Kulturwissenschaften', 'Social and Cultural Sciences'],
//       ['Sozialwesen', 'Social Work'],
//       ['Wirtschaft', 'Business'],
//     ].map((dep, i) =>
//       makeEnumOption(`FB${('00' + i).slice(-2)}`, [
//         `FB${('00' + i).slice(-2)} ${dep[0]}`,
//         `DEPT${('00' + i).slice(-2)} ${dep[1]}`,
//       ]),
//     ),
//   }),
// ];

export const countryTranslations = {
  Afghanistan: ['Afghanistan', 'Afghanistan'],
  Egypt: ['Ägypten', 'Egypt'],
  Albania: ['Albanien', 'Albania'],
  Algeria: ['Algerien', 'Algeria'],
  Andorra: ['Andorra', 'Andorra'],
  Angola: ['Angola', 'Angola'],
  AntiguaandBarbuda: ['Antigua und Barbuda', 'Antigua and Barbuda'],
  EquatorialGuinea: ['Äquatorialguinea', 'Equatorial guinea'],
  Argentina: ['Argentinien', 'Argentina'],
  Armenia: ['Armenien', 'Armenia'],
  Azerbaijan: ['Aserbaidschan', 'Azerbaijan'],
  Ethiopia: ['Äthiopien', 'Ethiopia'],
  Australia: ['Australien', 'Australia'],
  Bahamas: ['Bahamas', 'Bahamas'],
  Bahrain: ['Bahrain', 'Bahrain'],
  Bangladesh: ['Bangladesch', 'Bangladesh'],
  Barbados: ['Barbados', 'Barbados'],
  Belarus: ['Belarus', 'Belarus'],
  Belgium: ['Belgien', 'Belgium'],
  Belize: ['Belize', 'Belize'],
  Benin: ['Benin', 'Benin'],
  Bhutan: ['Bhutan', 'Bhutan'],
  Bolivia: ['Bolivien', 'Bolivia'],
  BosniaandHerzegovina: ['Bosnien und Herzegowina', 'Bosnia and Herzegovina'],
  Botswana: ['Botsuana', 'Botsuana'],
  Brazil: ['Brasilien', 'Brazil'],
  BruneiDarussalam: ['Brunei Darussalam', 'Brunei Darussalam'],
  Bulgaria: ['Bulgarien', 'Bulgaria'],
  BurkinaFaso: ['Burkina Faso', 'Burkina Faso'],
  Burundi: ['Burundi', 'Burundi'],
  CaboVerde: ['Cabo Verde', 'Cabo Verde'],
  Chile: ['Chile', 'Chile'],
  China: ['China', 'China'],
  CookIslands: ['Cookinseln', 'Cook islands'],
  CostaRica: ['Costa Rica', 'Costa Rica'],
  Denmark: ['Dänemark', 'Denmark'],
  Germany: ['Deutschland', 'Germany'],
  Dominica: ['Dominica', 'Dominica'],
  DominicanRepublic: ['Dominikanische Republik', 'Dominican Republic'],
  Djibouti: ['Dschibuti', 'Jibuti'],
  Ecuador: ['Ecuador', 'Ecuador'],
  ElSalvador: ['El Salvador', 'El Salvador'],
  Eritrea: ['Eritrea', 'Eritrea'],
  Estonia: ['Estland', 'Estonia'],
  Fiji: ['Fidschi', 'Fiji'],
  Finland: ['Finnland', 'Finland'],
  France: ['Frankreich', 'France'],
  Gabon: ['Gabun', 'Gab'],
  Gambia: ['Gambia', 'Gambia'],
  Georgia: ['Georgien', 'Georgia'],
  Ghana: ['Ghana', 'Ghana'],
  Grenada: ['Grenada', 'Grenada'],
  Greece: ['Griechenland', 'Greece'],
  GreatBritain: ['Großbritannien', 'Great Britain'],
  Guatemala: ['Guatemala', 'Guatemala'],
  Guinea: ['Guinea', 'Guinea'],
  'Guinea-Bissau': ['Guinea-Bissau', 'Guinea-Bissau'],
  Guyana: ['Guyana', 'Guyana'],
  Haiti: ['Haiti', 'Haiti'],
  Honduras: ['Honduras', 'Honduras'],
  India: ['Indien', 'India'],
  Indonesia: ['Indonesien', 'Indonesia'],
  Iraq: ['Irak', 'Iraq'],
  Iran: ['Iran', 'Iran'],
  Ireland: ['Irland', 'Ireland'],
  Iceland: ['Island', 'Iceland'],
  Israel: ['Israel', 'Israel'],
  Italy: ['Italien', 'Italy'],
  Jamaica: ['Jamaika', 'Jamaica'],
  Japan: ['Japan', 'Japan'],
  Yemen: ['Jemen', 'Yemen'],
  Jordan: ['Jordanien', 'Jordan'],
  Cambodia: ['Kambodscha', 'Cambodia'],
  Cameroon: ['Kamerun', 'Cameroon'],
  Canada: ['Kanada', 'Canada'],
  Kazakhstan: ['Kasachstan', 'Kazakhstan'],
  Qatar: ['Katar', 'Qatar'],
  Kenya: ['Kenia', 'Kenya'],
  Kyrgyzstan: ['Kirgisistan', 'Kyrgyzstan'],
  Kiribati: ['Kiribati', 'Kiribati'],
  Colombia: ['Kolumbien', 'Colombia'],
  Comoros: ['Komoren', 'Comor'],
  Congo: ['Kongo', 'Congo'],
  DemocraticRepublicoftheCongo: ['Kongo, Demokratische Republik', 'Congo, Democratic Republic'],
  NorthKorea: ['Korea, Nord', 'Korea, North'],
  SouthKorea: ['Korea, Süd', 'Korea, South'],
  Kosovo: ['Kosovo', 'Kosovo'],
  Croatia: ['Kroatien', 'Croatia'],
  Cuba: ['Kuba', 'Cuba'],
  Kuwait: ['Kuwait', 'Kuwait'],
  Laos: ['Laos', 'Laos'],
  Lesotho: ['Lesotho', 'Lesotho'],
  Latvia: ['Lettland', 'Latvia'],
  Lebanon: ['Libanon', 'Lebanon'],
  Liberia: ['Liberia', 'Liberia'],
  Libya: ['Libyen', 'Libya'],
  Liechtenstein: ['Liechtenstein', 'Liechtenstein'],
  Lithuania: ['Litauen', 'Lithuania'],
  Luxembourg: ['Luxemburg', 'Luxembourg'],
  Madagascar: ['Madagaskar', 'Madagascar'],
  Malawi: ['Malawi', 'Malawi'],
  Malaysia: ['Malaysia', 'Malaysia'],
  Maldives: ['Malediven', 'Maldives'],
  Mali: ['Mali', 'Mali'],
  Malta: ['Malta', 'Malta'],
  Morocco: ['Marokko', 'Morocco'],
  MarshallIslands: ['Marshallinseln', 'Marshall Islands'],
  Mauritania: ['Mauretanien', 'Mauritania'],
  Mauritius: ['Mauritius', 'Mauritius'],
  Mexico: ['Mexiko', 'Mexico'],
  Micronesia: ['Mikronesien', 'Micronesia'],
  Moldova: ['Moldau', 'Vltava'],
  Monaco: ['Monaco', 'Monaco'],
  Mongolia: ['Mongolei', 'Mongolia'],
  Montenegro: ['Montenegro', 'Montenegro'],
  Mozambique: ['Mosambik', 'Mozambique'],
  Myanmar: ['Myanmar', 'Myanmar'],
  Namibia: ['Namibia', 'Namibia'],
  Nauru: ['Nauru', 'Nauru'],
  Nepal: ['Nepal', 'Nepal'],
  NewZealand: ['Neuseeland', 'New Zealand'],
  Nicaragua: ['Nicaragua', 'Nicaragua'],
  Netherlands: ['Niederlande', 'Netherlands'],
  Niger: ['Niger', 'Niger'],
  Nigeria: ['Nigeria', 'Nigeria'],
  NorthMacedonia: ['Nordmazedonien', 'Northern Macedonia'],
  Norway: ['Norwegen', 'Norway'],
  Oman: ['Oman', 'Oman'],
  Austria: ['Österreich', 'Austria'],
  Pakistan: ['Pakistan', 'Pakistan'],
  Palestine: ['Palästina', 'Palestine'],
  Palau: ['Palau', 'Palau'],
  Panama: ['Panama', 'Panama'],
  PapuaNewGuinea: ['Papua-Neuguinea', 'Papua New Guinea'],
  Paraguay: ['Paraguay', 'Paraguay'],
  Peru: ['Peru', 'Peru'],
  Philippines: ['Philippinen', 'Philippines'],
  Poland: ['Polen', 'Poland'],
  Portugal: ['Portugal', 'Portugal'],
  Rwanda: ['Ruanda', 'Rwanda'],
  Romania: ['Rumänien', 'Romania'],
  Russia: ['Russland', 'Russia'],
  SolomonIslands: ['Salomonen', 'Salomons'],
  Zambia: ['Sambia', 'Zambia'],
  Samoa: ['Samoa', 'Samoa'],
  SanMarino: ['San Marino', 'San Marino'],
  SãoToméandPríncipe: ['São Tomé und Príncipe', 'São Tomé and Príncipe'],
  SaudiArabia: ['Saudi-Arabien', 'Saudi Arabia'],
  Sweden: ['Schweden', 'Sweden'],
  Switzerland: ['Schweiz', 'Switzerland'],
  Senegal: ['Senegal', 'Senegal'],
  Serbia: ['Serbien', 'Serbia'],
  Seychelles: ['Seychellen', 'Seychelles'],
  SierraLeone: ['Sierra Leone', 'Sierra Leone'],
  Zimbabwe: ['Simbabwe', 'Zimbabwe'],
  Singapore: ['Singapur', 'Singapore'],
  Slovakia: ['Slowakei', 'Slovakia'],
  Slovenia: ['Slowenien', 'Slovenia'],
  Somalia: ['Somalia', 'Somalia'],
  Spain: ['Spanien', 'Spain'],
  SriLanka: ['Sri Lanka', 'Sri Lanka'],
  'St.Kitts and Nevis': ['St. Kitts und Nevis', 'St. Kitts and Nevis'],
  'St.Lucia': ['St. Lucia', 'St. Lucia'],
  'St.Vincent and the Grenadines': ['St. Vincent und die Grenadinen', 'St. Vincent and the Grenadines'],
  SouthAfrica: ['Südafrika', 'South Africa'],
  Sudan: ['Sudan', 'Sudan'],
  SouthSudan: ['Südsudan', 'South Sudan'],
  Suriname: ['Suriname', 'Suriname'],
  Syria: ['Syrien', 'Syria'],
  Tajikistan: ['Tadschikistan', 'Tajikistan'],
  Taiwan: ['Taiwan', 'Taiwan'],
  Tanzania: ['Tansania', 'Tanzania'],
  Thailand: ['Thailand', 'Thailand'],
  'Timor-Leste': ['Timor-Leste', 'Timor-Leste'],
  Togo: ['Togo', 'Toogo'],
  Tonga: ['Tonga', 'Tonga'],
  TrinidadandTobago: ['Trinidad und Tobago', 'Trinidad and Tobago'],
  Chad: ['Tschad', 'Chad'],
  CzechRepublic: ['Tschechische Republik', 'Czech Republic'],
  Tunisia: ['Tunesien', 'Tunisia'],
  Turkey: ['Türkei', 'Turkey'],
  Turkmenistan: ['Turkmenistan', 'Turkmenistan'],
  Tuvalu: ['Tuvalu', 'Tuvalu'],
  Uganda: ['Uganda', 'Uganda'],
  Ukraine: ['Ukraine', 'Ukraine'],
  Hungary: ['Ungarn', 'Hungary'],
  Uruguay: ['Uruguay', 'Uruguay'],
  Uzbekistan: ['Usbekistan', 'Uzbekistan'],
  Vanuatu: ['Vanuatu', 'Vanuatu'],
  VaticanCity: ['Vatikanstadt', 'Vatican city'],
  Venezuela: ['Venezuela', 'Venezuela'],
  'UnitedArab Emirates': ['Vereinigte Arabische Emirate', 'United Arab Emirates'],
  UnitedStatesofAmerica: ['Vereinigte Staaten von Amerika', 'United States of America'],
  Vietnam: ['Vietnam', 'Vietnam'],
  'Central African Republic': ['Zentralafrikanische Republik', 'Central African Republic'],
  Cyprus: ['Zypern', 'Cyprus'],
  Other: ['Sonstiges', 'Other'],
};

export enum MatchingCountry {
  Afghanistan = 'Afghanistan',
  Egypt = 'Egypt',
  Albania = 'Albania',
  Algeria = 'Algeria',
  Andorra = 'Andorra',
  Angola = 'Angola',
  AntiguaandBarbuda = 'AntiguaandBarbuda',
  EquatorialGuinea = 'EquatorialGuinea',
  Argentina = 'Argentina',
  Armenia = 'Armenia',
  Azerbaijan = 'Azerbaijan',
  Ethiopia = 'Ethiopia',
  Australia = 'Australia',
  Bahamas = 'Bahamas',
  Bahrain = 'Bahrain',
  Bangladesh = 'Bangladesh',
  Barbados = 'Barbados',
  Belarus = 'Belarus',
  Belgium = 'Belgium',
  Belize = 'Belize',
  Benin = 'Benin',
  Bhutan = 'Bhutan',
  Bolivia = 'Bolivia',
  BosniaandHerzegovina = 'BosniaandHerzegovina',
  Botswana = 'Botswana',
  Brazil = 'Brazil',
  BruneiDarussalam = 'BruneiDarussalam',
  Bulgaria = 'Bulgaria',
  BurkinaFaso = 'BurkinaFaso',
  Burundi = 'Burundi',
  CaboVerde = 'CaboVerde',
  Chile = 'Chile',
  China = 'China',
  CookIslands = 'CookIslands',
  CostaRica = 'CostaRica',
  Denmark = 'Denmark',
  Germany = 'Germany',
  Dominica = 'Dominica',
  DominicanRepublic = 'DominicanRepublic',
  Djibouti = 'Djibouti',
  Ecuador = 'Ecuador',
  ElSalvador = 'ElSalvador',
  Eritrea = 'Eritrea',
  Estonia = 'Estonia',
  Fiji = 'Fiji',
  Finland = 'Finland',
  France = 'France',
  Gabon = 'Gabon',
  Gambia = 'Gambia',
  Georgia = 'Georgia',
  Ghana = 'Ghana',
  Grenada = 'Grenada',
  Greece = 'Greece',
  GreatBritain = 'GreatBritain',
  Guatemala = 'Guatemala',
  Guinea = 'Guinea',
  GuineaBissau = 'GuineaBissau',
  Guyana = 'Guyana',
  Haiti = 'Haiti',
  Honduras = 'Honduras',
  India = 'India',
  Indonesia = 'Indonesia',
  Iraq = 'Iraq',
  Iran = 'Iran',
  Ireland = 'Ireland',
  Iceland = 'Iceland',
  Israel = 'Israel',
  Italy = 'Italy',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Yemen = 'Yemen',
  Jordan = 'Jordan',
  Cambodia = 'Cambodia',
  Cameroon = 'Cameroon',
  Canada = 'Canada',
  Kazakhstan = 'Kazakhstan',
  Qatar = 'Qatar',
  Kenya = 'Kenya',
  Kyrgyzstan = 'Kyrgyzstan',
  Kiribati = 'Kiribati',
  Colombia = 'Colombia',
  Comoros = 'Comoros',
  Congo = 'Congo',
  DemocraticRepublicoftheCongo = 'DemocraticRepublicoftheCongo',
  NorthKorea = 'NorthKorea',
  SouthKorea = 'SouthKorea',
  Kosovo = 'Kosovo',
  Croatia = 'Croatia',
  Cuba = 'Cuba',
  Kuwait = 'Kuwait',
  Laos = 'Laos',
  Lesotho = 'Lesotho',
  Latvia = 'Latvia',
  Lebanon = 'Lebanon',
  Liberia = 'Liberia',
  Libya = 'Libya',
  Liechtenstein = 'Liechtenstein',
  Lithuania = 'Lithuania',
  Luxembourg = 'Luxembourg',
  Madagascar = 'Madagascar',
  Malawi = 'Malawi',
  Malaysia = 'Malaysia',
  Maldives = 'Maldives',
  Mali = 'Mali',
  Malta = 'Malta',
  Morocco = 'Morocco',
  MarshallIslands = 'MarshallIslands',
  Mauritania = 'Mauritania',
  Mauritius = 'Mauritius',
  Mexico = 'Mexico',
  Micronesia = 'Micronesia',
  Moldova = 'Moldova',
  Monaco = 'Monaco',
  Mongolia = 'Mongolia',
  Montenegro = 'Montenegro',
  Mozambique = 'Mozambique',
  Myanmar = 'Myanmar',
  Namibia = 'Namibia',
  Nauru = 'Nauru',
  Nepal = 'Nepal',
  NewZealand = 'NewZealand',
  Nicaragua = 'Nicaragua',
  Netherlands = 'Netherlands',
  Niger = 'Niger',
  Nigeria = 'Nigeria',
  NorthMacedonia = 'NorthMacedonia',
  Norway = 'Norway',
  Oman = 'Oman',
  Austria = 'Austria',
  Pakistan = 'Pakistan',
  Palestine = 'Palestine',
  Palau = 'Palau',
  Panama = 'Panama',
  PapuaNewGuinea = 'PapuaNewGuinea',
  Paraguay = 'Paraguay',
  Peru = 'Peru',
  Philippines = 'Philippines',
  Poland = 'Poland',
  Portugal = 'Portugal',
  Rwanda = 'Rwanda',
  Romania = 'Romania',
  Russia = 'Russia',
  SolomonIslands = 'SolomonIslands',
  Zambia = 'Zambia',
  Samoa = 'Samoa',
  SanMarino = 'SanMarino',
  SaoTomeandPrincipe = 'SaoTomeandPrincipe',
  SaudiArabia = 'SaudiArabia',
  Sweden = 'Sweden',
  Switzerland = 'Switzerland',
  Senegal = 'Senegal',
  Serbia = 'Serbia',
  Seychelles = 'Seychelles',
  SierraLeone = 'SierraLeone',
  Zimbabwe = 'Zimbabwe',
  Singapore = 'Singapore',
  Slovakia = 'Slovakia',
  Slovenia = 'Slovenia',
  Somalia = 'Somalia',
  Spain = 'Spain',
  SriLanka = 'SriLanka',
  StKittsandNevis = 'StKittsandNevis',
  StLucia = 'StLucia',
  StVincentandtheGrenadines = 'StVincentandtheGrenadines',
  SouthAfrica = 'SouthAfrica',
  Sudan = 'Sudan',
  SouthSudan = 'SouthSudan',
  Suriname = 'Suriname',
  Syria = 'Syria',
  Tajikistan = 'Tajikistan',
  Taiwan = 'Taiwan',
  Tanzania = 'Tanzania',
  Thailand = 'Thailand',
  TimorLeste = 'TimorLeste',
  Togo = 'Togo',
  Tonga = 'Tonga',
  TrinidadandTobago = 'TrinidadandTobago',
  Chad = 'Chad',
  CzechRepublic = 'CzechRepublic',
  Tunisia = 'Tunisia',
  Turkey = 'Turkey',
  Turkmenistan = 'Turkmenistan',
  Tuvalu = 'Tuvalu',
  Uganda = 'Uganda',
  Ukraine = 'Ukraine',
  Hungary = 'Hungary',
  Uruguay = 'Uruguay',
  Uzbekistan = 'Uzbekistan',
  Vanuatu = 'Vanuatu',
  VaticanCity = 'VaticanCity',
  Venezuela = 'Venezuela',
  UnitedArabEmirates = 'UnitedArabEmirates',
  UnitedStatesofAmerica = 'UnitedStatesofAmerica',
  Vietnam = 'Vietnam',
  CentralAfricanRepublic = 'CentralAfricanRepublic',
  Cyprus = 'Cyprus',
  Other = 'Other',
}
